import {
  Box, FormControl, FormLabel, Select, Text,
} from '@chakra-ui/react';
import useUpdateField from '../useUpdateField';
import OptionsList from './OptionsList';

const layouts = [{
  key: 'row',
  value: 'Horizontal',
}, {
  key: 'column',
  value: 'Vertical',
}];

const RadioOptions = ({ field }) => {
  const [layout, setLayout] = useUpdateField(field, 'props.direction');

  return (
    <Box>
      <Text fontWeight="bold" mb="2">Radio options</Text>
      <OptionsList field={field} />
      <FormControl mt="4">
        <FormLabel fontSize="sm" mb="1">Direction</FormLabel>
        <Select value={layout} onChange={(e) => setLayout(e.target.value)}>
          {layouts.map(({ key, value }) => <option key={key} value={key}>{value}</option>)}
        </Select>
      </FormControl>
    </Box>
  );
};

export default RadioOptions;
